import { render, staticRenderFns } from "./ai-signup.vue?vue&type=template&id=189178bc&scoped=true"
import script from "./ai-signup.vue?vue&type=script&lang=ts"
export * from "./ai-signup.vue?vue&type=script&lang=ts"
import style0 from "./ai-signup.vue?vue&type=style&index=0&id=189178bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189178bc",
  null
  
)

export default component.exports